<template>
  <div>
    <div class="ni-container unselectable">
    <span class="ni-minus ni-button" @mousedown="repeat(decrease)" @mouseup="clearRepeat" @mouseleave="clearRepeat"
          :style="{ width: buttonWidth }">
      <span class="ni-helper"></span>
      <i class="material-icons ni-image">remove</i>
    </span>
      <input ref="input" @change="onInput" @keypress="onKeyPress"
             type="text"
             class="ni-input"
             :value="value"
             :step="step" :min="min" :max="max">
      <span class="ni-plus ni-button" @mousedown="repeat(increase)" @mouseup="clearRepeat" @mouseleave="clearRepeat"
            :style="{ width: buttonWidth }">
      <span class="ni-helper"></span>
      <i class="material-icons ni-image">add</i>
      <span class="ni-helper"></span>
    </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NumericInput",
    props: {
      value: {
        type: [Number, String],
        default: 0
      },
      values: {
        type: Array,
        default: [],
      },
      buttonWidth: {
        type: String,
        default: "38px"
      },
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 999999
      }
    },
    data() {
      return {
        stepDelay: 400,
        divisor: 1.25,
        minSpeed: 50,
        timer: null,
        step: 1,
        mask: /^\d{1,6}$/ // positive numbers and 0
      }
    },
    computed: {
      range() {
        if (!Array.isArray(this.values) || !this.values.length) {
          return null;
        }

        const values = this.values
          .map(x => parseFloat(x))
          .filter(x => !isNaN(x) && x > 0)
          .sort((a, b) => a - b);

        if (!values.length) {
          return null;
        }

        values.unshift(0);

        return values;
      }
    },
    methods: {
      onKeyPress(e) {
        e = e || window.event;
        const charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        const charStr = String.fromCharCode(charCode);
        const value = this.$refs.input.value;
        const newValue = [value.slice(0, e.target.selectionStart), charStr, value.slice(e.target.selectionEnd)].join('');
        if (this.testValue(newValue)) {
          return true;
        }
        e.preventDefault();
        return false;
      },
      onInput() {
        let v = this.$refs.input.value;
        let newValue = parseFloat(v);
        if (Array.isArray(this.range)) {
          newValue = this.range[Math.min(0, this.range.indexOf(newValue))];
        }
        if (this.testValue(newValue)) {
          this.$refs.input.value = newValue;
          this.$emit('input', newValue)
        }
      },
      increase() {
        let v = this.$refs.input.value;
        let newValue = parseFloat(v);
        if (Array.isArray(this.range)) {
          newValue = this.range[Math.min(this.range.length + 1, this.range.indexOf(newValue) + 1)];
        } else {
          newValue += this.step;
        }
        if (this.testValue(newValue)) {
          this.$refs.input.value = newValue;
          this.$emit('input', newValue)
        }
      },
      decrease() {
        let v = this.$refs.input.value;
        let newValue = parseFloat(v);
        if (Array.isArray(this.range)) {
          newValue = this.range[Math.max(0, this.range.indexOf(newValue) - 1)];
        } else {
          newValue -= this.step;
        }
        if (this.testValue(newValue)) {
          this.$refs.input.value = newValue;
          this.$emit('input', newValue)
        }
      },
      repeat(fn) {
        fn();

        let interval = this.stepDelay;
        const stepper = () => {
          fn();
          clearInterval(this.timer);
          interval = (interval < this.minSpeed) ? this.minSpeed : parseInt(interval / this.divisor);
          this.timer = setInterval(stepper, interval);
        };

        this.timer = setInterval(stepper, interval);
      },
      clearRepeat() {
        clearInterval(this.timer);
      },
      testValue(value) {
        if (this.mask.test(value)) {
          if (typeof value === 'string') {
            value = parseFloat(value);
          }
          return ((typeof this.min === 'number' && value >= this.min) && (typeof this.max === 'number' && value <=
            this.max));
        }
        return false;
      }
    }
  }
</script>

<style scoped>
  .unselectable {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .ni-container {
    display: flex;
    margin: 0px;
    padding: 0px;
    min-width: 60px;
    height: 100%
  }

  .ni-button {
    width: 38px;
    height: 100%;
    text-align: center;
    position: relative;
  }

  .ni-button:hover {
    background: #CCCCCC;
  }

  .ni-plus {
    height: 100%;
    float: right;
    border: 1px solid rgba(255,255,255,0.12);
  }

  .ni-minus {
    float: left;
    height: 100%;
    border: 1px solid rgba(255,255,255,0.12);
  }

  .ni-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%)
  }

  td .ni-image {
    font-size: 15px;
  }

  .ni-helper {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }

  .ni-input {
    flex-grow: 1;
    width: 10px;
    text-align: center;
    border: 0px solid rgba(255,255,255,0.12);
    border-top-width: 1px;
    border-bottom-width: 1px;
    padding: 0px;
    height: auto;
  }

  .ni-input::-webkit-clear-button,
  .ni-input::-ms-clear {
    display: none;
  }
</style>
